"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.object.to-string.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _report = require("@/api/report.api");
var _format = require("@/utils/format");
var _vuePropertyDecorator = require("vue-property-decorator");
var _PieChart = _interopRequireDefault(require("../PieChart.vue"));
var CategoryChart = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CategoryChart, _Vue);
  var _super = (0, _createSuper2.default)(CategoryChart);
  function CategoryChart() {
    var _this;
    (0, _classCallCheck2.default)(this, CategoryChart);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "orderType", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "seriesAmount", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "seriesProfit", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "legend", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "data", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "colorByCate", {
      "Băng Keo": "#d63a15",
      "Màng Xốp Hơi": "#3366cd",
      "Màng PE": "#fd9c00",
      "Màng PE Foam": "#0295ca",
      "Thùng Carton": "#119618",
      "Túi Nilong": "#af008f",
      "Túi Đựng Rác": "#9e409c"
    });
    return _this;
  }
  (0, _createClass2.default)(CategoryChart, [{
    key: "formatter",
    value: function formatter(_ref) {
      var name = _ref.name,
        percent = _ref.percent,
        value = _ref.value,
        seriesName = _ref.seriesName;
      return "".concat(seriesName, "<br/>").concat(name, ": ").concat((0, _format.formatNumberVN)(value), "\u0111 (").concat(percent, "%)");
    }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _this2 = this;
        var query, res, totalAmount, totalProfit, seriesAmount, seriesProfit, legend;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  fromDate: this.date.from,
                  toDate: this.date.to,
                  orderType: this.orderType
                };
                _context.next = 3;
                return _report.reportApi.category(query);
              case 3:
                res = _context.sent;
                this.data = res.data.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    percent: Math.round(e.profit / e.amount * 100) || 0
                  });
                });
                totalAmount = res.data.reduce(function (prev, cur) {
                  return prev + cur.amount;
                }, 0);
                totalProfit = res.data.reduce(function (prev, cur) {
                  return prev + cur.profit;
                }, 0);
                seriesAmount = res.data.map(function (e) {
                  return {
                    value: e.amount,
                    name: e.cateName,
                    itemStyle: {
                      color: _this2.colorByCate[e.cateName]
                    }
                  };
                });
                seriesProfit = res.data.map(function (e) {
                  return {
                    value: e.profit,
                    name: e.cateName,
                    itemStyle: {
                      color: _this2.colorByCate[e.cateName]
                    }
                  };
                });
                this.seriesAmount = [{
                  name: "Doanh số theo danh mục",
                  type: "pie",
                  data: seriesAmount,
                  animationDuration: 2600,
                  radius: "55%",
                  label: {
                    show: true,
                    formatter: "{b} ({d}%)"
                  }
                }];
                this.seriesProfit = [{
                  name: "Lợi nhuận theo danh mục",
                  type: "pie",
                  data: seriesProfit,
                  animationDuration: 2600,
                  radius: "55%",
                  label: {
                    show: true,
                    formatter: "{b} ({d}%)"
                  }
                }];
                legend = res.data.map(function (e) {
                  return e.cateName;
                });
                this.legend = legend;
                _context.next = 15;
                return this.$nextTick();
              case 15:
                this.$refs.amountChart.initChart();
                this.$refs.profitChat.initChart();
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
  return CategoryChart;
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CategoryChart.prototype, "date", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CategoryChart.prototype, "orderType", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("date", {
  immediate: true
}), (0, _vuePropertyDecorator.Watch)("orderType")], CategoryChart.prototype, "fetchData", null);
CategoryChart = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    PieChart: _PieChart.default
  }
})], CategoryChart);
var _default = CategoryChart;
exports.default = _default;